
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveaway-picker/results",
      function () {
        return require("private-next-pages/giveaway-picker/results/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveaway-picker/results"])
      });
    }
  